module.exports = __webpack_public_path__ + "img/bahrain.e9decad2.svg";